export default "/static/build/rezan_03.png";